import React from 'react'
import priceUtils from './price'
import addMonths from 'date-fns/addMonths'

import {
  CURRENCIES,
} from 'settings'

const getLineItemsInfo = (subscriptionLineItems) => {
  if(!subscriptionLineItems) return null
  let totalCurrency = null
  
  const lineItems = subscriptionLineItems.map(item => {
    const qty = item.quantity
    const price = item.price.unit_amount
    const title = item.price.nickname
    const total = qty * price
    const currency = CURRENCIES.find(c => c.id == item.price.currency)
    totalCurrency = currency
    return {
      qty,
      price,
      title,
      total,
      currency,
    }
  })

  const total = lineItems.reduce((all, item) => all + item.total, 0)

  return {
    currency: totalCurrency,
    lineItems,
    total,
  }  
}

const getSubscriptionInfo = (subscription) => {

  if(!subscription) return null

  const periodStartDate = new Date(subscription.current_period_start * 1000)
  const periodEndDate = new Date(subscription.current_period_end * 1000)

  const periodStart = periodStartDate.toLocaleDateString()
  const periodEnd = periodEndDate.toLocaleDateString()
  const nextPeriodStart = addMonths(periodEndDate, 1).toLocaleDateString()

  const {
    currency,
    lineItems,
    total,
  } = getLineItemsInfo(subscription.items.data)

  return {
    periodStart,
    periodEnd,
    nextPeriodStart,
    currency,
    lineItems,
    total,
  }  
}

const getLineItemsTable = (subscriptionLineItems) => {
  if(!subscriptionLineItems) return []
  const {
    currency,
    lineItems,
    total,
  } = getLineItemsInfo(subscriptionLineItems)

  const lineItemData = lineItems
    .filter(lineItem => lineItem.qty > 0)
    .map(lineItem => {
      return {
        title: lineItem.title,
        value: `${ lineItem.qty } x ${ lineItem.currency.symbol }${ priceUtils.displayPrice(lineItem.price) }`,
      }
    })

  const totalItem = {
    title: <strong>Total</strong>,
    value: <span><strong>{ currency.symbol }{ priceUtils.displayPrice(total) }</strong> per month</span>,
  }

  return lineItemData.concat([totalItem])
}

const getSubscriptionTable = (subscription) => {

  const info = getSubscriptionInfo(subscription)

  const baseItems = [{
    title: 'Current Period Start',
    value: info.periodStart,
  },{
    title: 'Current Period End',
    value: info.periodEnd,
  }]

  if(info.lineItems.length <= 0) return baseItems

  const lineItemRows = getLineItemsTable(subscription.items.data)

  return baseItems.concat(lineItemRows)
}

const utils = {
  getLineItemsInfo,
  getSubscriptionInfo,
  getSubscriptionTable,
  getLineItemsTable,
}

export default utils